var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-no-results';
                    var viewUrl = 'sprite.svg#view-icon-no-results';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 92 92',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };